import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import { Box, ToggleButton, ToggleButtonGroup, Tooltip } from "@mui/material";
import { PickerViewMode } from "../viewMode";

interface PickerViewSwitcherProps {
  value: PickerViewMode;
  onChange: (value: PickerViewMode) => void;
  compact?: boolean;
}

const PickerViewSwitcher = ({
  value,
  onChange,
  compact = false,
}: PickerViewSwitcherProps) => (
  <ToggleButtonGroup
    exclusive
    value={value}
    onChange={(_, next: PickerViewMode | null) => {
      if (next) onChange(next);
    }}
    aria-label="My Picks view"
    size="small"
    sx={{
      height: compact ? 36 : 44,
      p: compact ? "2px" : "4px",
      gap: 0.5,
      border: 1,
      borderColor: "divider",
      borderRadius: 99,
      bgcolor: "surface.high",
      "& .MuiToggleButtonGroup-grouped": {
        m: 0,
        width: compact ? 32 : 48,
        height: compact ? 32 : 36,
        p: 0,
        border: 0,
        borderRadius: "999px !important",
        color: "text.primary",
        "&.Mui-selected": {
          bgcolor: "primary.main",
          color: "primary.contrastText",
        },
      },
    }}
  >
    <Tooltip title="Birds Eye overview">
      <ToggleButton value="overview" aria-label="Birds Eye overview view">
        <VisibilityOutlinedIcon sx={{ fontSize: compact ? 18 : 22 }} />
      </ToggleButton>
    </Tooltip>
    <Tooltip title="Game Wheel">
      <ToggleButton value="wheel" aria-label="Game Wheel view">
        <Box
          component="span"
          aria-hidden
          sx={{
            width: compact ? 18 : 22,
            height: compact ? 18 : 22,
            bgcolor: "currentColor",
            mask: "url(/assets/icons/game-wheel.svg) center / contain no-repeat",
            WebkitMask:
              "url(/assets/icons/game-wheel.svg) center / contain no-repeat",
          }}
        />
      </ToggleButton>
    </Tooltip>
  </ToggleButtonGroup>
);

export default PickerViewSwitcher;
